import axios from "axios";
import { config } from "./config";

export const httpClient = axios.create({
  baseURL: config.backendUrl
});



// WEBPACK FOOTER //
// ./src/request.js